import css from "./Dropdown.module.scss";
import { motion } from "framer-motion";
import { useState } from "react";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import DropdownLink from "../atoms/DropdownLink";

export default function Dropdown({
    iconName,
    items,
    gap = "10px",
    cursor = "pointer",
}) {
    // const [isHover, setIsHover] = useState(false);
    // const [show, setShow] = useState(false)

    // const toggleHover = () => {
    //    setIsHover(!isHover);
    // };

    // function toggleShow() {
    //    setShow(!show)
    // }

    const { buttonProps, itemProps, isOpen } = useDropdownMenu(items && items.length);

    const subMenuAnimate = {
        enter: {
            opacity: 1,
            rotateX: 0,
            transition: {
                duration: 0.3,
            },
            display: "flex",
        },
        exit: {
            opacity: 0,
            rotateX: -15,
            transition: {
                duration: 0.3,
                // delay: 0.3,
            },
            transitionEnd: {
                display: "none",
            },
        },
    };

    return (
        <motion.div
            className={css["wrapper"]}

            // onClick={toggleShow}

            // onHoverStart={() => setIsHover(true)}
            // onHoverEnd={() => setShow(false)}

            // onMouseEnter={() => setIsHover(true)}
            // onMouseLeave={() => setShow(false)}

            // onTap={() => setShow(true)}
            // onTapCancel={() => setShow(false)}
        >
            <button
                className={css["button"]}
                style={{ cursor: cursor }}
                {...buttonProps}
            >
                <i className={`${css.icon} fad fa-${iconName}`} />
            </button>

            <motion.div
                role="menu"
                style={{ gap: gap }}
                className={css["menu"]}
                initial="exit"
                animate={isOpen ? "enter" : "exit"}
                variants={subMenuAnimate}
            >
                {/* {children} */}
                {items && items.map((item, index) => {
                   return <DropdownLink {...item} 
                //    {...itemProps[index]}
                    key={item.label} />
                })}
            </motion.div>
        </motion.div>
    );
}
